import React, { useState, useEffect, } from 'react';

import lpllogo from '../../assets/images/logo.png';
import user from '../../assets/images/user.png';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';

import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import SearchableSelect from '../../components/searchableSelect';
import Form from 'react-bootstrap/Form';
import GetUserData from "../../utilities/getUserDetails";

const RoleOptions = [
    { label: 'Super Admin', value: 'Super Admin' },
    { label: 'Admin', value: 'Admin' },
    { label: 'User', value: 'User' },
];

const UserOption = [
    { label: 'Awadhesh', value: 'Awadhesh ' },
    { label: 'Jitender', value: 'Jitender' },
    { label: 'Saksham', value: 'Saksham' },
];
const ProjectOption =  [
    { label: 'Sample Collection', value: 'sample collection ' },
    { label: 'FTR', value: 'FTR' },
    { label: 'NFTR', value: 'NFTR' },
];



function UserRoleMenuMapping() {
    const [isScrolled, setIsScrolled] = useState(false);
    const handleScroll = () => {
        if (window.scrollY > 50) { 
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleSelect = (option) => {
        console.log();
    };


    // const userRole = .UserRole;
    const userRole = GetUserData().UserRole;
    useEffect(() => {
        if (userRole != 'Admin') {
            return (
                <div>
                    Restricted for this user
                </div>
            );
        }
    }, [])

    return (
        <>
                <section className='container-fluid'>
                    <div className='Page-title d-flex align-items-center'>
                        <h3 className='mb-2'>User Project Menu Mapping</h3>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='card-content'>
                                        <div className='row'>
                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                <div className="did-floating-label-content">                                                    
                                                    <SearchableSelect options={RoleOptions} onSelect={handleSelect} /> 
                                                    <label className="did-floating-label" style={{marginTop: '-18px'}}>Role</label>                                                   
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                <div className="did-floating-label-content">                                                    
                                                    <SearchableSelect options={UserOption} onSelect={handleSelect} /> 
                                                    <label className="did-floating-label" style={{marginTop: '-18px'}}>User Name</label>                                                   
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                <div className="did-floating-label-content">                                                    
                                                    <SearchableSelect options={ProjectOption} onSelect={handleSelect} /> 
                                                    <label className="did-floating-label" style={{marginTop: '-18px'}}>Project Name</label>                                                   
                                                </div>
                                            </div>
                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                <div className="did-floating-label-content"> 
                                                    <label className="did-floating-label"  style={{marginTop: '-24px'}}>Action</label>
                                                    {['checkbox'].map((type) => (
                                                        <div key={`inline-${type}`} className="mt-2 mb-3">
                                                        <Form.Check
                                                            inline
                                                            label="View"
                                                            name="group1"
                                                            type={type}
                                                            id={`inline-${type}-1`}
                                                             className='mb-2'
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Update"
                                                            name="group1"
                                                            type={type}
                                                            id={`inline-${type}-2`}
                                                             className='mb-2'
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Delete"
                                                            name="group1"
                                                            type={type}
                                                            id={`inline-${type}-3`}
                                                             className='mb-2'
                                                        />
                                                        
                                                        </div>
                                                    ))}
                                                </div>
                                                
                                            </div>
                                            
                                            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3'>
                                                <fieldset className='custom-fieldset'>
                                                    <legend>Menu List</legend>
                                                    <div className='fieldset-container'>
                                                        <div className='row'>
                                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                                <Form.Check
                                                                    label="Menu Name 1"
                                                                    name="group1"
                                                                    type='checkbox'
                                                                    id={`inline-Checkbox-4`}
                                                                    className='mb-2'
                                                                />
                                                            </div>
                                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                                <Form.Check
                                                                    label="Menu Name 1"
                                                                    name="group1"
                                                                    type='checkbox'
                                                                    id={`inline-Checkbox-5`}
                                                                     className='mb-2'
                                                                />
                                                            </div>
                                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                                <Form.Check
                                                                    label="Menu Name 1"
                                                                    name="group1"
                                                                    type='checkbox'
                                                                    id={`inline-Checkbox-6`}
                                                                     className='mb-2'
                                                                />
                                                            </div>
                                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                                <Form.Check
                                                                    label="Menu Name 1"
                                                                    name="group1"
                                                                    type='checkbox'
                                                                    id={`inline-Checkbox-7`}
                                                                     className='mb-2'
                                                                />
                                                            </div>
                                                            <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3'>
                                                                <Form.Check
                                                                    label="Menu Name 1"
                                                                    name="group1"
                                                                    type='checkbox'
                                                                    id={`inline-Checkbox-8`}
                                                                    className='mb-2'
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>

                                            <div className='text-end'>                                                
                                                <Button variant='primary btn-sm me-2' >Save</Button>
                                                <Button variant='secondary btn-sm me-2' >Reset</Button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
        </>
    )
}
export default UserRoleMenuMapping;
